import { createAction } from 'typesafe-actions';

export const validateHouseYearFilterAction = createAction('filters/validateHouseYearFilter')<'min' | 'max'>();
